import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../utils/network-call/network-call";

export const ChangePasswordLoader = async (args: LoaderFunctionArgs) => {
    const checkPasswordResetTokenResponse = await networkCall('/users/check-password-reset', {
        method: 'POST',
        body: {
            token: args.params.token
        }
    });

    return { checkPasswordResetTokenResponse, token: args.params.token };
};